import PackageConfig from './PackageConfig'
import Employee from './Employee'
export class SavePackageConfigRequest {
    PackageConfig: PackageConfig;
    SavedByEmployee: Employee;
}

export default SavePackageConfigRequest;